import {
    Dropdown,
    DROPDOWN_TYPE_REWARD_BASE, DROPDOWN_TYPE_REWARD_OPERATOR
} from "./Dropdow";
import {REWARD_POINTS} from "../../pages/SingleCampaign";
import {HiOutlineTrash} from "react-icons/hi";
import TextInput from "./TextInput";

export const RewardBuilder = ({reward, onDelete, includeDeleteButton, onInputChange, missingValue, setSelected}) => {
    return (
        <div className="flex flex-row w-full justify-between items-center gap-3">
            <div className="flex flex-row items-center gap-3 flex-wrap">
                <span className="text-body-md text-body">Add points with formula</span>
                <Dropdown initialValue={reward.rewardBase} id={reward.id} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_REWARD_BASE}/>
                <Dropdown initialValue={reward.operator} id={reward.id} setSelected={setSelected} dropdownType={DROPDOWN_TYPE_REWARD_OPERATOR}/>
                <div className="w-28">
                    <TextInput
                        type="number"
                        placeholder="Points"
                        error={missingValue === reward.id ? "Required" : undefined}
                        value={reward.points ?? ""}
                        onChange={(event) => onInputChange(reward.id, REWARD_POINTS, event.target.value)}
                    />
                </div>
            </div>
            {includeDeleteButton ? (
                <button
                    onClick={onDelete}
                    type="button"
                    className="inline-flex items-center justify-center w-10 h-10 rounded-full text-signature-coral hover:bg-surface-soft transition-colors"
                    aria-label="Delete reward"
                >
                    <HiOutlineTrash className="w-5 h-5" />
                </button>
            ) : null}
        </div>
    );
}
